// test1559
(1559 && 0);
